import { ReceivedPaymentFormController } from './receivedPaymentForm.controller';
import template from './receivedPaymentForm.html';

export const receivedPaymentFormComponent = {
  name: 'receivedPaymentComponent',
  restrict: 'E',
  template,
  controller: ReceivedPaymentFormController,
  controllerAs: 'vm',
  bindings: {
    model: '=',
    form: '='
  }
};
